// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "html{font-family:Inter,sans-serif;font-size:16px;font-weight:600;text-size-adjust:none;-moz-text-size-adjust:none;-webkit-text-size-adjust:none;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}*,:after,:before{box-sizing:border-box;margin:0;padding:0;-moz-user-select:none;user-select:none;-ms-user-select:none;-webkit-user-select:none;-webkit-touch-callout:none}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
